const projectEn = {
    project: require('../../lang/en/project/Project').default,
};

export default projectEn;